import React, { FunctionComponent, useMemo } from 'react';
import styles from 'src/components/Timer/Timer.css';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import selectors from 'src/app/redux/selectors';
import Countdown, { zeroPad } from 'react-countdown';
import cn from 'classnames';

export interface ITimerProps {
  expiresInTime: number;
  onCompletion: () => void;
  className?: string;
}

const Timer: FunctionComponent<ITimerProps> = (props) => {
  const { expiresInTime, onCompletion, className } = props;
  const userTimeZoneId = useSelector(selectors.profile.getUserTimeZoneId);

  const time = useMemo(() => {
    return moment(expiresInTime).tz(userTimeZoneId).valueOf();
  }, [expiresInTime, userTimeZoneId]);

  const canShowTimer = useMemo(() => {
    return moment(expiresInTime).tz(userTimeZoneId).isAfter(moment.tz(userTimeZoneId));
  }, [expiresInTime, userTimeZoneId]);

  const getFormattedTimer = (days: number, hours: number, minutes: number, seconds: number) => {
    if (days === 0 && hours === 0) {
      // Exclude days and hours from formatted timer if hours and days is 0
      return `${zeroPad(minutes)}:${zeroPad(seconds)}`;
    } else if (days === 0) {
     // Exclude days from formatted timer if only days is 0
      return `${zeroPad(hours)}:${zeroPad(minutes)}:${zeroPad(seconds)}`;
    } else {
      return `${zeroPad(days)}:${zeroPad(hours)}:${zeroPad(minutes)}:${zeroPad(seconds)}`;
    }
  };

  const rendererTimer = (timerProps: { days: number; hours: number; minutes: number; seconds: number }) => {
    const { days, hours, minutes, seconds } = timerProps;
    const formattedTimer = getFormattedTimer(days, hours, minutes, seconds);
    return (
      <div className={cn(styles.timer, className)}>
        {formattedTimer}
      </div>
    );
  };

  const onTimerCompletion = () => {
    onCompletion();
  };

  return canShowTimer ? (
    <Countdown key={time} date={time} renderer={rendererTimer} onComplete={onTimerCompletion} />
  ) : null;
};

export default Timer;
